const fakeData = [
  {
    id: 1,
    title: 'Listen to the audio and fill in blank the missing word',
    subTitle: 'Nghe và điền từ còn thiếu vào chỗ trống',
    question: '',
    type: 'FillWordInTheBlank',
    questionAudio: 'https://cloud.softech.cloud/storage/Data/Sentences/44c5a865-8c7e-4201-a9b6-dd66c2d8ae93.mp3',
    answers: [
      { id: 1, text: "hello, I'm Bill.", answer: 'hello' },
      { id: 2, text: "hi, Bill.", answer: 'hi' },
    ],
  },
  {
    id: 2,
    title: 'Choose the words in the box to fill in the blank.',
    subTitle: 'Chọn từ phù hợp để điền vào ô trống.',
    words: ['were', "don't", "wouldn't", 'since', 'in spite'],
    type: 'SelectWord',
    questions: ['My brother wants to be # dentist.', "I've been riding horses # I was 3 years old."],
    answers: ['were', 'since'],
  },
  {
    id: 3,
    title: 'Listen and fill the blanks to make the correct words',
    subTitle: 'Nghe và điền vào chỗ trống để tạo từ đúng',
    type: 'FillLetterInTheBlank',
    question: 'house',
    filterVowels: true,
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/11c5fedf-cd9e-426b-810f-85aaba584272.mp3',
  },
  {
    id: 4,
    title: 'Find the underlined part that needs correction in each following sentence.',
    subTitle: 'Tìm lỗi sai trong câu.',
    type: 'Underlined',
    question: 'Despite the # rain #, we still # to school on time.',
    answers: [
      { id: 1, answer: 'heavily', isCorrect: true },
      { id: 2, answer: 'yesterday', isCorrect: false },
      { id: 3, answer: 'went', isCorrect: false },
    ]
  },
  {
    id: 5,
    title: 'Listen and arrange the sentences with the corresponding sound.',
    subTitle: 'Nghe và sắp xếp câu với âm thanh tương ứng.',
    type: 'Matching',
    question: '',
    answers: [
      { id: 1, answer: 'The bear is sleeping under the tree', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/810f185a-23ee-4067-b2dc-d29eed41cd21.mp3' },
      { id: 2, answer: 'The hippo is swimming very slowly', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/b181cb2d-09d0-47c6-8021-930174e243d0.mp3' },
      { id: 3, answer: 'The cat is playing with the woolen roll', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/0c535b1d-93cc-42ae-a0d3-fb82f16381cb.mp3' },
    ],
  },
  {
    id: 6,
    title: 'Unscramble letters to make a completed word.',
    subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
    type: 'Unscramble',
    question: 'class',
    answer: 'class',
    settings: {
      question: {
        // shuffedType: 'word',
        shuffedType: 'character',
      },
    },
  },
  {
    id: 7,
    title: 'Listen to the audio and fill in blank the missing word.',
    subTitle: 'Nghe và điền từ còn thiếu vào chỗ trống.',
    type: 'FillInTheBlank',
    question: 'Although they don’t have enough money, they buy a modern ___.',
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/1edd45b5-514a-437e-a0b0-1025bde74898.mp3',
    answer: 'apartment',
  }
  , {
    id: 8,
    title: 'Choose the correct definition of the word.',
    subTitle: 'Chọn định nghĩa đúng của từ.',
    question: 'Pencil',
    type: 'OneChoice',
    answers: [
      { id: 1, answer: 'a piece of furniture that consists of a flat top supported by legs', isCorrect: false },
      { id: 2, answer: 'a type of soft white stone', isCorrect: false },
      { id: 3, answer: 'a narrow pice of woord, of a metal of plastic case, containing a black or coloured substance,user for drawing of writing', isCorrect: true },
    ],
  },
  {
    id: 9,
    title: 'Write the past simple and past participle form of these following words.',
    subTitle: 'Viết dạng quá khứ và dạng phân từ hai của động từ.',
    question: '',
    audio: '',
    type: 'Conjugation',
    answers: [
      { id: 1, answer: 'Go', answersList: ['went', 'gone'], isCorrect: true, audio: '' },
      { id: 2, answer: 'Get', answersList: ['got', 'got'], isCorrect: true, audio: '' },
    ]
  },
  {
    id: 10,
    title: 'Arrange columns A and B into complete sentences.',
    subTitle: 'Sắp xếp 2 cột A và B thành câu hoàn chỉnh.',
    type: 'MatchingTwoColumn',
    question: '',
    answers: [
      {
        id: 1,
        textLeft: 'These people live in the mountains,',
        textRight: 'or you will get fat.',
      },
      {
        id: 2,
        textLeft: 'To help your community, you can join in Be a Buddy,',
        textRight: 'and people will throw rubbish into them.',
      },
      {
        id: 3,
        textLeft: `Don't eat too close to your bedtime,`,
        textRight: 'but he never sells them.',
      },
      {
        id: 4,
        textLeft: 'My dad can make beautiful plieces of art from empty eggshells,',
        textRight: 'so they have a lot of fresh air.',
      },
      {
        id: 5,
        textLeft: 'Place a bin here and there,',
        textRight: 'or you can start your own activities.',
      },
    ],
  }, {
    id: 11,
    title: 'Listen and click stressing words in the sentence.',
    subTitle: 'Nghe và chọn từ được nhấn trọng âm trong câu.',
    question: 'Listen and click three / two / four stressing words in the sentence',
    type: 'SelectWordsInSentence',
    answers: [
      { answer: 'How', isCorrect: true },
      { answer: 'many', isCorrect: false },
      { answer: 'lessons', isCorrect: true },
      { answer: 'do', isCorrect: false },
      { answer: 'you', isCorrect: false },
      { answer: 'have', isCorrect: true },
      { answer: 'today?', isCorrect: true },
    ],
    audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/359ec200-8b26-40f6-9975-a9fac4c25f8f.mp3',
  }

]

export default fakeData